import { FetchApi } from '../lib/anuket-http';
import { configs } from '../configs';
import { Observable } from 'rx';
import {
  streamFail,
  streamHook
} from './Streams';

const countryStreamId = 'CountryStream';
const stateStreamId = 'StateStream';

export function fetchCountries() {

  const url = configs.ATHLINKS_API_HOST + `/Country/List`;

  streamFail(
    countryStreamId,
    FetchApi.doFetch(
      url,
      {method: 'GET'}
    ),
    (msg) => {
      return (msg.ErrorMessage ? { error: msg.ErrorMessage } : { result: msg });
    }
  );
}

export function fetchStates(countryId) {
  const url = configs.ATHLINKS_API_HOST + `/Country/StateProvList/${countryId}`;

  const streamId = stateStreamId+'-'+countryId;

  streamFail(
    streamId,
    FetchApi.doFetch(
      url,
      {method: 'GET'}
    ),
    (msg) => {
      return (msg.ErrorMessage ? { error: msg.ErrorMessage } : { result: msg });
    }
  );
}

export function getCountryStream() {
  return streamHook(countryStreamId, { fetching: true });
}

export function getStateStream(countryId) {
  return countryId
    ? streamHook(stateStreamId+'-'+countryId, { fetching: true }) : Observable.just({ result: [] });
}



/** WEBPACK FOOTER **
 ** ./data/CountryStateStreams.js
 **/